const { RichText, InnerBlocks } = wp.blockEditor;
import SvgComponent from './svgAccordion';

export default ({ attributes }) => {
  const {
    variant,
    title,
    titleTag,
    padded,
    isParent,
    containerized,
    subtitle,
    color,
    textColor,
    hasMargin,
    border,
    idAccordion,
  } = attributes;
  return (
    <details
      className={`
        Accordion ${variant}
        ${isParent ? 'Accordion--parent' : 'Accordion--child'}
        ${containerized ? 'Container' : ''} ${border ? '' : 'borderBefore'}`}
      id={idAccordion}
    >
      <summary className={color}>
        <div
          className={`Accordion__heading  ${
            variant === 'default' ? textColor : ''
          } ${hasMargin ? '' : 'noPadding'}`}
        >
          <RichText.Content
            tagName={titleTag}
            value={title}
            className="Accordion__title"
          />
          <span className={`Accordion__marker ${variant}`}>
            {variant == 'default' && <SvgComponent />}
          </span>
        </div>
        {variant == 'withDescription' && (
          <RichText.Content
            tagName="p"
            value={subtitle}
            className="Accordion__subtitle"
          />
        )}
      </summary>
      <div className={`Accordion__content ${!padded ? 'no-padding' : ''}`}>
        <InnerBlocks.Content />
      </div>
    </details>
  );
};
